<template>
  <ul class="AiTags">
    <li
      v-for="(item, index) in items"
      :key="index"
      class="AiTag"
      :class="`AiTag--${item.color}`">
      {{ item.text }}
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { AiTagItem } from './types';

export interface AiTagsProps {
  items: AiTagItem[];
}

withDefaults(defineProps<AiTagsProps>(), {
  items: () => [],
});
</script>

<style scoped lang="scss">
.AiTags {
  display: flex;
  flex-direction: row;
  gap: 4px;
  margin-bottom: 8px;
  padding: 0;
  list-style: none;
}

.AiTag {
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
  letter-spacing: 0.05em;
  text-align: center;
  vertical-align: middle;
  line-height: 1.5;

  &--pink {
    background-color: #ffe6ef;
    color: #d4024d;
  }
}
</style>
